<template>
  <div>
    <v-dialog v-model="dialogLoad" width="80%" persistent transition="dialog-bottom-transition">
      <s-toolbar close :load="useServiceLayer == '0'" label="Atención de Pedido" @close="closeSAP($event)" @load="AddSAP($event)" >
        <template v-slot:options>
          <v-tooltip bottom >
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on" small @click="AddSAP_API()" elevation="0" v-if="useServiceLayer != '0'">
                <v-icon style="font-size:18px;">mdi-cloud-upload</v-icon>
              </v-btn>
            </template>
            <span>Service Layer SAP</span>
          </v-tooltip>
        </template>
      </s-toolbar>
      <v-card>
        <v-container>
          <v-row>
            <v-col lg="9">
              <s-toolbar label="Detalle de Pedidos"></s-toolbar>
              <!-- <v-data-table hide-default-footer :items-per-page="-1" dense :items="itemsOrder" :headers="config.headers" item-key="DerID">
              </v-data-table> -->
              <v-data-table hide-default-footer :items-per-page="-1" dense :items="itemsOrder" :headers="config.headers" item-key="DerID">

                <template v-slot:item.hasSeal="{ item }">
                  <v-checkbox v-model="item.hasSeal" hide-details dense @change="toggleSeal(item)"></v-checkbox>
                </template>
                <!-- <template v-slot:item.DerCodeSeal="{ item }">
                  <v-text-field
                    v-if="item.hasSeal"
                    v-model="item.DerCodeSeal"
                    dense
                    hide-details
                    placeholder="Ingrese precinto"
                    outlined
                  ></v-text-field>
                  <span v-else>-</span>
                </template> -->
              </v-data-table>
              
              <v-divider class="my-3"></v-divider>

              <!-- Sección de ingreso de precintos por cada item marcado -->
              <div v-if="itemsOrder.some(i => i.hasSeal)">
                <s-toolbar label="Ingrese los datos"></s-toolbar>
                <v-container>
                  <v-row v-for="(item, idx) in itemsOrder.filter(i => i.hasSeal)" :key="item.DerID" class="mb-4">
                    <v-col cols="12">
                      <strong>{{ item.DerNumLine }} - {{ item.DerDescription }}</strong>
                      <div class="grey--text text--darken-1">Cantidad: {{ Number(item.DerQuantityServed) || Number(item.DerQuantity) || 0 }}</div>
                    </v-col>

                    <v-col
                      cols="6"
                      v-for="n in (Number(item.DerQuantityServed) || Number(item.DerQuantity) || 0)"
                      :key="`seal-${item.DerID}-${n}`"
                      class="mb-2"
                    >
                      <s-text :label="`Cod. Kit Seguridad ${n}`" v-model="item.SealCodes[n - 1]" />
                    </v-col>
                  </v-row>
                </v-container>
              </div>
              <!--  <s-crud noToolbar add-no-function searchInput remove :config="config"
               :filter="filter" @rowSelected="rowSelected($event)"> </s-crud>-->
            </v-col>
            <v-col lg="3">
              <v-card>
                <v-container>
                  <h3 style="text-align: center;">Datos de Usuario</h3>
                  <v-col>
                    <v-row>
                      <v-col class="s-col-text">
                        <s-text label="Despachado por" v-model="UserInfo.NtpFullName" readonly />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="s-col-text">
                        <s-text label="Registrado por" v-model="UserInfo.NtpFullName" readonly />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="s-col-text">
                        <s-toolbar-person v-model="person" @returnPerson="returnPerson($event)" addBirthDate addTypeSex noEdit autofocus />
                        <s-text label="Recogido por" v-model="getPerson.NtpFullName" readonly />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col class="s-col-text">
                        <s-textarea label="Comentarios" v-model="RequestComments"></s-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="s-col-text">
                        <s-text label="Glosa de Asiento Contable" v-model="RequestAccount" />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="processingSAP" :persistent="messageProcessingSAP.length == 0" width="400">
      <v-card color="primary" dark>
        <v-card-text v-if="messageProcessingSAP.length == 0">
          Por favor espere
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
        <v-card-text v-else>
          <div class="text--white pt-4">
            Error al realizar operacion en SAP <br />
            {{ messageProcessingSAP }}
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-if="dialogRequirement" v-model="dialogRequirement" width="unset" persistent>
        <rptOutRequeriment
            :data="dataReport" 
            @close="closeReport()">
        </rptOutRequeriment>
    </v-dialog>
  </div>
</template>
<script>
import _sAttentionDetail from "@/services/Logistics/AttentionDetailService";
import _sRequirementService from "@/services/Logistics/RequirementService";
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson";
import _sGenParamService 	from "@/services/General/ParameterService";
import rptOutRequeriment from './rptOutRequeriment.vue';
export default {
  components: { sToolbarPerson, rptOutRequeriment },
  props: {
    req: null,
    items: null,
    dialogLoad: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    config: {
      service: _sAttentionDetail,
      model: {
        DerID: "ID",
        DerNumLine: "int",
        ArtCode: "string",
        DerDescription: "string",
        UnitMeasurement: "string",
        ItemName: "string",
        Location1: "string",
        Location2: "string",
        DerQuantity: "int",
        SecStatus: 1,
      },
      headers: [
        {
          text: "Precinto",
          value: "hasSeal",
          width: 100,
        },
        {
          text: "N°Linea.",
          value: "DerNumLine",
          width: 75,
        },
        {
          text: "Descripcion",
          value: "DerDescription",
          width: 350,
        },
        {
          text: "Ubicacion1",
          value: "Location1",
          width: 90,
        },
        {
          text: "Ubicacion2",
          value: "Location2",
          width: 90,
        },

        {
          text: "Cantidad Atendida",
          value: "DerQuantityServed",
          width: 90,
        },
        {
          text: "Centro Costos",
          value: "CceName",
          width: 200,
          align: "center",
        },
        ,
        {
          text: "Tipo Costo",
          value: "TypeCostName",
          width: 100,
        },
        {
          text: "Linea Negocio",
          value: "BslName",
          width: 200,
          align: "center",
        },
        {
          text: "Proyecto",
          value: "PrjName",
          width: 200,
          align: "center",
        },
        {
          text: "Cuenta Contable",
          value: "ReqAccount",
          align: "center",
          width: 150,
        },
      ],
    },
    selected: {},
    loadingSap: false,
    UserInfo: {},
    person: null,
    getPerson: {
      PrsDocumentNumber: "",
      NtpFullName: null,
    },
    RequestComments: null,
    RequestAccount: null,
    processingSAP: false,
    errorSap: false,
    messageProcessingSAP: "",
    useServiceLayer: null,
    dialogRequirement: false,
    dataReport: {},
    UsePdfCrystal: null
  }),
  computed: {
    filter() {
      return { ReqID: this.reqID };
    },
    itemsOrder() {
      return this.items.sort((x, y) => x.DerNumLine - y.DerNumLine);
    },
  },
  created() {
    this.initialize();
    this.loadParameter();
  },
  methods: {
    rowSelected(item) {
      this.selected = item;
    },
    toggleSeal(item) {
      console.log("item", item);
      // Si se marca, inicializar un array de precintos con la longitud indicada
      if (item.hasSeal) {
        const count = Number(item.DerQuantityServed ?? item.DerQuantity) || 0;
        // Vue.set / this.$set para preservar reactividad
        this.$set(item, "SealCodes", Array.from({ length: count }, () => ""));
      } else {
        // Si se desmarca, limpiar los precintos
        this.$set(item, "SealCodes", null);
        item.DerCodeSeal = null;
      }
    },
    closeSAP() {
      this.getPerson = {
        PrsDocumentNumber: "",
        NtpFullName: null,
      };
      this.RequestComments = null;
      this.RequestAccount = null;
      this.$emit("close");
    },
    LoadSap() {
      this.loadingSap = true;
    },
    initialize() {
      this.UserInfo = this.$fun.getUserInfo();
    },
    returnPerson(person) {
      if (person != null) {
        this.getPerson.NtpFullName = person.NtpFullName;
        this.getPerson.NtpID = person.NtpID;
        this.getPerson.MevPersonName = person.NtpName;
        this.getPerson.TypePersonDocument = person.TypePersonDocument;
        this.getPerson.PrsDocumentNumber = person.PrsDocumentNumber;
      }
    },
    isValidate(item) {
      let isValid;
      let message;

      isValid = this.$fun.getUserSAPInfo() == null ? false : this.$fun.getUserSAPInfo().UsrID == 0 ? false : true;

      if (!isValid) message = "Credenciales SAP Incorrectas";
      else {
        isValid = item.RequestDispatchedSAP != null;
        if (!isValid) message = "Registre el responsable del Despacho";
        else {
          isValid = item.RequestRegisteredSAP != null;
          if (!isValid) message = "Registre el responsable del Registro";
          else {
            isValid = item.RequestCollectedSAP != null;
            if (!isValid) message = "Registre el responsable del Recojo del requerimiento";
            else {
              isValid = item.RequestComments != null ? (item.RequestComments.length > 5 ? true : false) : false;
              if (!isValid) message = "La descripcion del comentario, debe contener mas caracteres";
              else {
                isValid = item.RequestAccount != null;
                if (!isValid) message = "Debe registrar los datos de la Cuenta Contable";
              }
            }
          }
        }
      }

      if (!isValid) this.$fun.alert(message, "warning");

      return isValid;
    },
    prepareDetailWithSeals() {
      // Trabajamos sobre this.items para mantener sincronía con la UI
      this.items.forEach((item) => {
        const count = Number(item.DerQuantityServed ?? item.DerQuantity) || 0;
        if (item.hasSeal) {
          if (!Array.isArray(item.SealCodes)) this.$set(item, "SealCodes", []);
          // Asegurar longitud y preservar valores existentes
          for (let i = 0; i < count; i++) {
            if (typeof item.SealCodes[i] === "undefined") this.$set(item.SealCodes, i, "");
          }
          // Truncar si hay más elementos de los necesarios
          item.SealCodes.length = count;
          // Filtrar y dejar solo los precintos con datos (no enviar vacíos)
          const filtered = (item.SealCodes || [])
            .map((s) => (s == null ? "" : String(s)))
            .map((s) => s.trim())
            .filter((s) => s.length > 0);
          if (filtered.length > 0) {
            this.$set(item, "SealCodes", filtered);
          } else {
            this.$set(item, "SealCodes", null);
          }
        } else {
          // Si no tiene precinto, limpiamos para no enviar datos residuales
          this.$set(item, "SealCodes", null);
        }
      });
      return this.items;
    },
    AddSAP() {
      this.messageProcessingSAP = "";
      var obj = {
        ReqID: this.req.ReqID,
        Detail: this.prepareDetailWithSeals(),
        ReqDocumentNumber: this.req.ReqDocumentNumber,
        UsrCreateID: this.$fun.getUserID(),
        RequestDispatchedSAP: this.UserInfo.PrsDocumentNumber,
        RequestRegisteredSAP: this.UserInfo.PrsDocumentNumber,
        RequestCollectedSAP: this.getPerson.PrsDocumentNumber,
        RequestComments: this.RequestComments,
        RequestAccount: this.RequestAccount,
        NtpDispatchedID: this.UserInfo.NtpID,
        NtpCollectedID: this.getPerson.NtpID,
      };
      console.log(obj);
      console.log(this.getPerson);
      if (this.isValidate(obj))
        this.$fun.alert("Seguro de Guardar?", "question").then((val) => {
          if (val.value) {
            this.processingSAP = true;
            _sAttentionDetail.loadsap(obj, this.$fun.getUserSAPInfo().UsrID).then(
              (r) => {
                if (r.status == 200) {
                  this.processingSAP = false;
                  this.loadingSap = false;
                  this.$fun.alert("Registro correcto", "success");
                  this.$emit("close");
                  _sAttentionDetail.reportpdf(obj, this.$fun.getUserID()).then((r) => {
                    this.$fun.downloadFile(r.data, this.$const.TypeFile.PDF, this.$fun.getUserID());
                  });
                }
              },
              (e) => {
                this.errorSap = true;
                this.messageProcessingSAP = e.response.data.Message;
                this.loadingSap = true;
                this.processingSAP = true;
              }
            );
          }
        });
    },
    AddSAP_API() {
      this.messageProcessingSAP = "";

      var obj = {
        ReqID: this.req.ReqID,
        Detail: this.prepareDetailWithSeals(),
        ReqDocumentNumber: this.req.ReqDocumentNumber,
        UsrCreateID: this.$fun.getUserID(),
        RequestDispatchedSAP: this.UserInfo.PrsDocumentNumber,
        RequestRegisteredSAP: this.UserInfo.PrsDocumentNumber,
        RequestCollectedSAP: this.getPerson.PrsDocumentNumber,
        RequestComments: this.RequestComments,
        RequestAccount: this.RequestAccount,
        NtpDispatchedID: this.UserInfo.NtpID,
        NtpCollectedID: this.getPerson.NtpID,
      };
      console.log(obj);
      console.log(this.getPerson);
      if (this.isValidate(obj))
        this.$fun.alert("Seguro de Guardar?", "question").then((val) => {
          if (val.value) {
            this.processingSAP = true;
            _sAttentionDetail.loadsap_api(obj, this.$fun.getUserID()).then(
              (r) => {
                if (r.status == 200) {
                  this.processingSAP = false;
                  this.loadingSap = false;
                  this.$fun.alert("Registro correcto", "success");

                  if(this.UsePdfCrystal == 1){
                    this.$emit("close");
                    _sAttentionDetail.reportpdf(obj, this.$fun.getUserID()).then((r) => {
                      this.$fun.downloadFile(r.data, this.$const.TypeFile.PDF, this.$fun.getUserID());
                    });
                  } else {
                    _sRequirementService.byID(obj, this.$fun.getUserID()).then((r) => {
                      this.dataReport = r.data;
                      console.log("this.dataReport", this.dataReport);
                      this.dialogRequirement = true;
                    });
                  }
                }
              },
              (e) => {
                this.errorSap = true;
                this.messageProcessingSAP = e.response.data.Message;
                this.loadingSap = true;
                this.processingSAP = true;
              }
            );
          }
        });
    },
    closeReport() {
      this.dialogRequirement = false;
      this.$emit("close");
    },
    loadParameter () {
      _sGenParamService
					.search(
						{ PrmName: "UseServiceLayer" },
						this.$fun.getUserID(),
					)
					.then(resp => {
						this.useServiceLayer = resp.data.PrmValue;
					});

      _sGenParamService
        .search(
          { PrmName: "UsePdfCrystal" },
          this.$fun.getUserID(),
        )
        .then(resp => {
          this.UsePdfCrystal = resp.data.PrmValue;
        });
    }

  },
};
</script>
